export type PaymentItem = {
  id: string;
  name: string;
  secondaryText?: string;
  paymentType: "success" | "failure";
};

// Define constants for payment item types.
export const PAYMENT_ITEM_TYPE = {
  SUCCESS: "success",
  FAILURE: "failure",
} as const;
